import { TgValidationModule, TgValidationDirective } from '@trademe/tangram';
import { NgModule } from '@angular/core';
import { ValidatorPipe } from './to-validator.pipe';
import { ValidationSchemaDirective } from '../directives/validation.directive';

@NgModule({
    imports: [TgValidationModule],
    declarations: [ValidationSchemaDirective, ValidatorPipe],
    exports: [ValidationSchemaDirective, ValidatorPipe],
    providers: [
        {
            provide: TgValidationDirective,
            useClass: ValidationSchemaDirective
        },
        ValidatorPipe
    ]
})
export class DraftValidationModule {}
